function translateCostTypesToEnglish(costTypes) {
    const translationMap = {
        "Otopark": "Parking",
        "Konaklama": "Accommodation",
        "Yemek": "Meal",
        "Yurtiçi Temsil İkram": "Domestic Complimentary Food & Drink",
        "Demirbaş": "Fixture",
        "Kongre / Sergi / Fuar": "Congress / Exhibition / Fair",
        "Eğitim / Seminer": "Training / Seminar",
        "Araç Kiralama": "Rent a car",
        "OGS-HGS": "Electronic Toll Collection",
        "Yakıt": "Fuel",
        "Araç Yıkama": "Car Washing",
        "Yurtdışı Temsil İkram": "International Complimentary Food & Drink",
        "Ulaşım": "Transportation",
        "Kargo ve Posta": "Shipping cost",
        "Kırtasiye ve Matbu Evrak": "Stationery",
        "Noter": "Notary",
        "Bakım ve Onarım": "Maintenance and Repair",
        "Teknik Hizmet": "Technical Service",
        "Motivasyon Bütçesi": "Motivation Budget",
        "Vize": "Visa",
        "Ofis İhtiyaçları": "Office Supplies",
        "Diğer": "Other"
    };

    return costTypes.map(item => ({
        type: translationMap[item.type] || item.type
    }));
}

function translatePaymentTypesToEnglish(paymentTypes) {
    const translationMap = {
        "Nakit": "Cash",
        "Şirket Kredi Kartı": "Company / Business Credit Card",
        "Merkezi Ödeme": "Central Payment"
    };

    return paymentTypes.map(item => ({
        type: translationMap[item.type] || item.type
    }));
}


let employeeInfo = null;

 function loadEmployeeInfo() {
    try {
        const employeeInfoStr = localStorage.getItem('employeeInfo');
        employeeInfo = JSON.parse(employeeInfoStr);
    } catch (error) {
        console.error("Employee info could not be parsed:", error);
    }
}

export async function getTranslatedCostTypes() {
    const costTypes = employeeInfo ? employeeInfo.costType : [];
    return translateCostTypesToEnglish(costTypes);
}

export async function getTranslatedPaymentTypes() {
    const paymentTypes = employeeInfo ? employeeInfo.paymentType : [];
    return translatePaymentTypesToEnglish(paymentTypes);
}
async function initialize() {
    loadEmployeeInfo();
    const translatedCostTypes = await getTranslatedCostTypes();
    const translatedPaymentTypes = await getTranslatedPaymentTypes();
    return { translatedCostTypes, translatedPaymentTypes };
}

export { initialize };

